const cookieKey = {
    /**
     * Used to store IEmailInformation across requests if the user refreshes
     */
    espiredEmail: "espired-email"
};

export default cookieKey;
